import React, { ReactNode, createContext, useContext } from 'react';

interface BriefFormContextProps {
    briefId?: string;
    singleFileUploads?: boolean;
}

const BriefFormContext = createContext<BriefFormContextProps>({});

interface BriefFormProviderProps {
    children: ReactNode;
    briefId?: string;
    singleFileUploads?: boolean;
}

export const BriefFormProvider: React.FC<BriefFormProviderProps> = ({
    children,
    briefId,
    singleFileUploads,
}) => {
    return (
        <BriefFormContext.Provider value={{ briefId, singleFileUploads }}>
            {children}
        </BriefFormContext.Provider>
    );
};

export const useBriefFormContext = () => {
    return useContext(BriefFormContext);
};
